/* Gemline Games — homepage interactions */
(function(){
'use strict';
/* ============================ HEADER SCROLL ============================ */
const header = document.getElementById('header');
const utilityBar = document.getElementById('utilityBar');
if (header) {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 30;
    header.classList.toggle('scrolled', scrolled);
    if (utilityBar) utilityBar.classList.toggle('hide', scrolled);
  });
}

/* ============================ MOBILE MENU ============================ */
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');
if (burger && mobileMenu) {
  burger.addEventListener('click', () => mobileMenu.classList.toggle('open'));
  mobileMenu.querySelectorAll('a').forEach(a =>
    a.addEventListener('click', () => mobileMenu.classList.remove('open'))
  );
}

/* ============================ REVEAL ON SCROLL ============================ */
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
}, { threshold:.15 });
document.querySelectorAll('.reveal:not(.in)').forEach(el => io.observe(el));

/* ============================ YEAR ============================ */
const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = new Date().getFullYear();

/* ============================ TOAST ============================ */
let toastTimer;
function showToast(msg){
  const t = document.getElementById('toast');
  if (!t) { console.log('[Gemline]', msg); return; }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 3400);
}

/* ============================ DROPDOWN CALENDAR ============================ */
(function(){
  const trigger   = document.getElementById('dateTrigger');
  const pop       = document.getElementById('calendar');
  const label     = document.getElementById('dateLabel');
  const monthEl   = document.getElementById('calMonth');
  const daysEl    = document.getElementById('calDays');
  const dowEl     = document.getElementById('calDow');
  const prevBtn   = document.getElementById('calPrev');
  const nextBtn   = document.getElementById('calNext');
  const clearBtn  = document.getElementById('calClear');
  const todayBtn  = document.getElementById('calToday');

  // If any essential element is missing, bail out silently so the rest of the page still works.
  if (!trigger || !pop || !label || !monthEl || !daysEl || !dowEl) {
    return;
  }

  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const DOW = ['Su','Mo','Tu','We','Th','Fr','Sa'];

  const today = new Date(); today.setHours(0,0,0,0);
  let view = new Date(today.getFullYear(), today.getMonth(), 1);
  let selected = null;

  // build day-of-week header once
  DOW.forEach(d => {
    const c = document.createElement('div');
    c.className = 'cal-dow'; c.textContent = d;
    dowEl.appendChild(c);
  });

  function sameDay(a,b){
    return a && b && a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();
  }

  function render(){
    monthEl.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
    daysEl.innerHTML = '';
    const firstDay = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
    const daysInMonth = new Date(view.getFullYear(), view.getMonth()+1, 0).getDate();

    // leading blanks
    for(let i=0;i<firstDay;i++){
      const blank = document.createElement('div');
      blank.className = 'cal-day empty';
      daysEl.appendChild(blank);
    }
    for(let d=1; d<=daysInMonth; d++){
      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'cal-day';
      cell.textContent = d;
      const cellDate = new Date(view.getFullYear(), view.getMonth(), d);

      if (cellDate < today){
        cell.classList.add('disabled');
        cell.disabled = true;
      } else {
        cell.addEventListener('click', () => {
          selected = cellDate;
          updateLabel();
          render();
          closeCal();
        });
      }
      if (sameDay(cellDate, today)) cell.classList.add('today');
      if (sameDay(cellDate, selected)) cell.classList.add('selected');
      daysEl.appendChild(cell);
    }
  }

  function updateLabel(){
    if (selected){
      const opts = { weekday:'short', month:'short', day:'numeric', year:'numeric' };
      label.textContent = selected.toLocaleDateString(undefined, opts);
      trigger.classList.remove('placeholder');
    } else {
      label.textContent = 'Select a date';
      trigger.classList.add('placeholder');
    }
  }

  function openCal(){
    pop.classList.add('open');
    trigger.setAttribute('aria-expanded','true');
    render();
  }
  function closeCal(){
    pop.classList.remove('open');
    trigger.setAttribute('aria-expanded','false');
  }

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    pop.classList.contains('open') ? closeCal() : openCal();
  });
  pop.addEventListener('click', e => e.stopPropagation());
  document.addEventListener('click', closeCal);
  document.addEventListener('keydown', e => { if(e.key==='Escape') closeCal(); });

  prevBtn.addEventListener('click', () => {
    view = new Date(view.getFullYear(), view.getMonth()-1, 1);
    render();
  });
  nextBtn.addEventListener('click', () => {
    view = new Date(view.getFullYear(), view.getMonth()+1, 1);
    render();
  });
  clearBtn.addEventListener('click', () => {
    selected = null; updateLabel(); render();
  });
  todayBtn.addEventListener('click', () => {
    view = new Date(today.getFullYear(), today.getMonth(), 1);
    selected = new Date(today);
    updateLabel(); render(); closeCal();
  });

  render();

  /* ============================ BOOK BUTTON → SHOPIFY CART ============================ */
  const bookForm = document.getElementById('bookingForm');
  const bookBtn  = document.getElementById('bookBtn');

  if (bookForm && bookBtn) {
    bookForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const game   = document.getElementById('game');
      const guests = document.getElementById('guests');
      const dateInput = document.getElementById('dateValue');

      if (!game.value) { showToast('Please choose an experience first.'); game.focus(); return; }
      if (!selected)   { openCal(); showToast('Pick your event date to continue.'); return; }

      // Store date as ISO (YYYY-MM-DD) — readable in the order admin and machine-parseable
      const pad = (n) => String(n).padStart(2, '0');
      const iso = selected.getFullYear() + '-' + pad(selected.getMonth() + 1) + '-' + pad(selected.getDate());
      dateInput.value = iso;

      const original = bookBtn.textContent;
      bookBtn.textContent = 'Adding to cart…';
      bookBtn.disabled = true;

      try {
        const formData = new FormData(bookForm);
        const res = await fetch(window.Shopify ? '/cart/add.js' : bookForm.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (res.ok) {
          showToast('\u2756 Reserved! Redirecting to checkout…');
          setTimeout(() => { window.location = '/checkout'; }, 700);
        } else {
          const err = await res.json().catch(() => ({}));
          showToast(err.description || 'That date is unavailable. Try another.');
          bookBtn.textContent = original;
          bookBtn.disabled = false;
        }
      } catch (err) {
        showToast('Connection issue — please try again.');
        bookBtn.textContent = original;
        bookBtn.disabled = false;
      }
    });
  }
})();
})();